<h1 class="nuestros-productos-d"> {{text.title}}</h1>

<div class="content-with-filled-button">
    <div class="content">
        <form class="form row" id="maxPeriodForm" [formGroup]="formGroup">
            <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-3">
                <vcl-form-field class="form" [label]="text.label" [msgErr]="textInformation">
                    <input vclInput id="inputAmountValue" voxelMask="currency" [config]="config"
                        [placeholder]="text.label" formControlName="newValue">
                </vcl-form-field>
            </div>
        </form>
    </div>
</div>

<app-controls class="controls" [hasPrevious]="true" 
    [nextLabel]="copyService.copies.max_period_request_code_button" [nextDisabled]="!formGroup.valid" (next)="next()">
</app-controls>